import { Grid2 } from "@mui/material";
import React from "react";
import { UploadImageStyles } from ".";
import { ReactComponent as ParentIcon } from "../../GlobalAssets/svg/parentIcon.svg";
import { ReactComponent as ClientIcon } from "../../GlobalAssets/svg/clientIcon.svg";

function UploadImage({ onClick, selectedOrg }) {
  return (
    <Grid2>
      <Grid2 className={UploadImageStyles.container} onClick={onClick}>
        <Grid2 className={UploadImageStyles.imgContainer}>
          {selectedOrg?.imagePath ? (
            <img
              src={selectedOrg?.imagePath}
              alt="img"
              className={UploadImageStyles.nameIcon}
            />
          ) : selectedOrg?.parentOrgName === null ? (
            <ParentIcon className={UploadImageStyles.nameIcon} />
          ) : (
            <ClientIcon className={UploadImageStyles.nameIcon} />
          )}
        </Grid2>
        <Grid2 className={UploadImageStyles.allowedImg}>
          Allowed *.jpeg, *.jpg, *.png, *.gif max size of 3 Mb
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default UploadImage;
